import React from 'react'

const PublicOffer = () => {
    return (
        <div className="mx-5">
            <p className="text-[1rem] lg:text-[2rem] font-bold tracking-wide text-headingColor mt-10">
                Публичная оферта о продаже товаров дистанционным способом (действует с 7 мая 2020 года)
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                1. Термины и определения
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                1.1. В настоящей оферте, если из контекста не следует иное, нижеприведенные термины с заглавной буквы
                имеют следующие значения.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                1.1.1. «Курьерская служба» — лица, оказывающие услуги по доставке Товаров от имени Продавца или
                сотрудники Продавца.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                1.1.2. «Продавец» — ООО «ООО «МВС» ИНН: 1215187738 / КПП: 121501001 / ОГРН: 1151215001728 / Юридический
                адрес: 424038, РМЭ, г.Йошкар-Ола, ул. Кирова, 9Б Телефон:89027397407 , созданное в соответствии с
                законодательством Российской Федерации и предоставляющий услуги общественного питания, в том числе
                дистанционным способом. Фактический адрес: 424038, РМЭ, г.Йошкар-Ола, ул. Кирова, 9б, указыван на сайте
                и соответствует действительности. Электронная почта:mon_tresor@bk.ru Телефон: 89027397407
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                1.1.3. «Покупатель» — любое дееспособное лицо, намеренное заказать или приобрести, либо заказывающий,
                приобретающий или использующий товары или услуги общественного питания исключительно для личных,
                семейных, домашних или иных нужд, не связанных с осуществлением предпринимательской деятельности.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                1.1.4. «Сайт» — https://mon-tresor.ru
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                1.1.5. «Телефон» 89027397407
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                1.1.6. «Товары или услуги общественного питания» — перечень продукции Продавца, представленный на Сайте.
                Продукция может отличаться от изображения на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                1.2. Для целей настоящей оферты термины, и определения в единственном числе относятся также и к терминам
                и
                определениям во множественном числе.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                2. Общие положения
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                2.1. Продавец и Покупатель гарантируют, что обладают дееспособностью, а также всеми правами,
                необходимыми для заключения и исполнения договора розничной купли-продажи дистанционным способом.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                2.2. Покупатель обязуется ознакомиться с условиями настоящей оферты, с информацией, указанной на Сайте в
                отношении Товаров и услуг общественного питания, с условиями участия в Программе лояльности, Политикой
                Конфиденциальности, Пользовательским соглашением.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                2.3. Продавец оставляет за собой право вносить изменения в настоящую оферту, в связи с чем Покупатель
                обязуется самостоятельно отслеживать наличие изменений в настоящей оферте. Редакции оферты,
                действовавших до даты, указанной в названии настоящей оферты, предоставляются по запросу (по Телефону)
                или указаны на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                2.4. При оформлении заказа дистанционно, Покупатель тем самым подтверждает, что он исполнил обязанности,
                предусмотренные пунктом 2.2. настоящей оферты.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                2.5. Договор розничной купли-продажи дистанционным способом считается заключенным с момента получения
                Продавцом сообщения о намерении Покупателя приобрести Товары или услуги общественного питания.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                2.6. Срок, в течение которого действует предложение о заключении договора розничной купли-продажи
                дистанционным способом, является бессрочным.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                3. Предмет Договора
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                3.1. Продавец продает Товары или услуги общественного питания по ценам, представленным на Сайте
                Продавца, и доставляет Курьерской службой, а Покупатель производит оплату и принимает Товары в
                соответствии с условиями настоящей оферты.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                3.2. Право собственности на Товары переходит к Покупателю в момент приемки Товаров Покупателем.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                4. Уведомления Покупателя
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                4.1. Продавец вправе осуществлять рассылку уведомлений о проводимых акциях и рекламных материалов по
                контактным данным Покупателя, полученных им в ходе настоящей оферты.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                4.2. Покупатель имеет право ознакомится с данными уведомлениями, указанных в пункте 4.1. настоящей
                оферты, либо отказаться от них.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                4.3. Продавец вправе совершать вызовы в адрес Пользователя в целях проведения маркетинговых исследований
                среди Покупателей и исследования предпочтений Покупателей; проведения розыгрышей призов среди
                Покупателей; проведения анализа оказываемых Продавцом услуг; урегулирования конфликтных ситуаций без
                получения от Пользователя согласия на совершение всех перечисленных выше действий.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                4.4. Продавец вправе отправлять сервисные сообщения, информирующие Покупателя о совершенном им заказе,
                его составе, этапах его обработки и о готовности заказа; такие сервисные сообщения отправляются
                автоматически, не могут быть отклонены Покупателем, направлены на контроль качества оказания услуг
                Покупателю и его информирование о надлежащем исполнении Продавцом своих обязательств по договору
                купли-продажи дистанционным способом.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                5. Оформление заказа Товаров
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                5.1. Заказ Покупателя может быть оформлен по Телефону и/или посредством заполнения электронной формы
                заказа на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                5.2. Покупатель обязуется предоставить достоверные данные, необходимые и достаточные для исполнения
                договора розничной купли-продажи Товаров дистанционным способом.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                5.3. В случае возникновения у Покупателя дополнительных вопросов, касающихся Товаров, перед оформлением
                Заказа Покупатель должен обратиться к Продавцу по Телефону для получения необходимой информации, в
                соответствии с режимом работы, указанным на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                5.4. Покупатель может заказать только те Товары или услуги общественного питания, которые есть в наличии
                у Продавца на момент оформления заказа у Продавца.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                5.5. Покупатель не имеет право изменить состав заказа после его оформления на доставку.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                5.6. При оформлении заказа по Телефону Продавец вправе осуществлять аудиозапись телефонного разговора с
                Пользователем, если указанные действия необходимы Продавцу для исполнения обязанностей по данной оферте,
                и оценки качества оказанных услуг, без получения от Пользователя согласия на совершение указанных
                действий.
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                5.7. При оформлении заказа посредством заполнения электронной формы заказа на Сайте Покупатель создает
                учетную запись в соответствии с Пользовательским соглашением, указанным на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                5.8. Если у Продавца отсутствует необходимое количество или ассортимент заказанных Покупателем Товаров
                или услуг общественного питания, Продавец информирует об этом Покупателя по телефону в течение 30 минут
                после получения заказа от Покупателя. Покупатель вправе согласиться принять Товары или услуги
                общественного питания в ином количестве или ассортименте, либо аннулировать свой заказ. В случае
                отсутствия ответа Покупателя Продавец вправе аннулировать Заказ Покупателя в полном объеме.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                5.9. Продавец вправе временно приостановить прием заказов в случае технических неполадок или отсутствия
                ингредиентов, необходимых для изготовления Товаров или услуг общественного питания.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                6. Доставка Товаров
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                6.1. Доставка Товаров осуществляется Курьерской службой по фактическому адресу, указанному Покупателем.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                6.2. Доставка Товаров в пределах зоны доставки осуществляется в соответствии с режимом работы Продавца,
                указанным на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                6.3. Доставка Товаров по адресам, не входящим в зону доставки (г.Йошкар-Ола), не осуществляется.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                6.4. Срок доставки заказа: 60 — 90 минут с момента принятия заказа. В случае нарушения установленных
                сроков доставки Товаров, в силу обстоятельств непреодолимой силы («форс-мажор») в соответствии с
                Разделом 9 настоящей оферты Продавец не считается просрочившим доставку. В случае поступления большого
                количества заказов, а также сложной дорожной обстановки или плохих погодных условий время доставки может
                быть увеличено до 120 минут
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                6.5. Доставка осуществляется при условии оплаты стоимости товаров или услуг общественного питания, в том
                числе и оплаты стоимости доставки Курьерской службой. Стоимость доставки Курьерской службой указана на
                сайте продавца.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                6.6. Продавец вправе отказаться от исполнения договора розничной купли-продажи дистанционным способом в
                том случае, если Курьерская служба по прибытии к фактическому адресу доставки Покупателя, не может
                осуществить фактическую передачу доставленных Товаров по вине Покупателя (Покупатель в течение 5 минут
                не отвечает на телефонный вызов или не открывает дверь Курьерской службе).
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                7. Оплата Товаров
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                7.1. Цены на Товары или услуги общественного питания и на услуги Курьерской службы самопределяются
                Продавцом в одностороннем порядке и указываются на Сайте.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                7.2. Оплата Товаров Покупателем производится в рублях Российской Федерации одним из следующих способов:
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                7.2.1. оплата осуществляется по факту получения Товаров или услуг общественного питания наличными
                денежными средствами, оплата наличными денежными средствами ограничена максимальной суммой заказа.
                Максимальная сумма заказа, при которой возможна оплата наличными денежными средствами, определяется
                Продавцом в одностороннем порядке и указывается на Сайте;
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                7.2.2. безналичным расчетом банковской картой по факту получения Товаров, при условии оснащения
                Курьерской службы мобильными POS-терминалами (о наличии возможности произвести оплату Товаров данным
                способом следует уточнять у Продавца).
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                7.3. Выдача либо направление Покупателю кассового чека:
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                7.3.1.На бумажном носителе, в случае совершения заказа Товаров через Телефон и оплаты в порядке,
                предусмотренном пунктом 7.2.1 настоящей оферты, пунктом 7.2.2 настоящей оферты, если Покупатель в момент
                совершения заказа не сообщил Продавцу о желании получить кассовый чек в электронном виде и не выполнил
                условия, предусмотренные пунктом 7.4.2 настоящей оферты.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                8. Возврат и обмен Товаров
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                8.1. Продавец обязан передать Покупателю Товары или услуги общественного питания, которые полностью
                соответствуют его заказу, качество которых соответствует информации, представленной Покупателю при
                заключении договора розничной купли-продажи дистанционным способом.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                8.2. При получении Товаров или услуг общественного питания Покупатель проверяет их соответствие своему
                заказу, комплектность и отсутствие претензий к внешнему виду в течение 5 (пяти) минут после их
                получения. Внешний вид Товаров или услуг общественного питания, может отличаться от их рекламного
                изображения.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                8.3. В случае выявления некачественных Товаров или услуг общественного питания, либо несоответствия
                полученных Товаров или услуг общественного питания заказу (отсутствие заявленных ингредиентов),
                Покупатель вправе потребовать замены таких Товаров или услуг общественного питания, сразу в течение 5
                (Пяти) минут после получения своего заказа обратившись по телефону указанному на сайте и обеспечив при
                этом полное сохранение Товара или услуг общественного питания Продавца.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                8.4. В случае невыполнения порядка предъявления претензии Покупателя по внешнему виду Товаров и их
                комплектности, предусмотренных пунктом 8.3, пунктом 8.4 настоящей оферты, претензии не принимаются.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                9. Форс-мажор
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                9.1. Любая из Сторон освобождается от ответственности за полное или частичное неисполнение своих
                обязательств по настоящей оферте, если это неисполнение было вызвано обстоятельствами непреодолимой
                силы. Обстоятельства непреодолимой силы означают чрезвычайные события и обстоятельства, которые Стороны
                не могли ни предвидеть, ни предотвратить разумными средствами. Такие чрезвычайные события или
                обстоятельства включают в себя, в частности: забастовки, наводнения, пожары, землетрясения и иные
                стихийные бедствия, войны, военные действия и так далее.
            </p>


            <p className="text-base text-textColor text-left md:text-left mt-10 font-bold">
                10. Ответственность Сторон публичной оферты
            </p>
            <p className="text-base text-textColor text-left md:text-left">
                10.1. Продавец не несет ответственности за ущерб, причиненный Покупателю вследствие ненадлежащего
                использования им Товаров или услуг общественного питания, приобретённых у Продавца.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                10.2. Продавец не отвечает за убытки Покупателя, возникшие в результате неправильного заполнения Заказа,
                в том числе неправильного указания своих данных.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                10.3. В случае злоупотребления Покупателем правами потребителя, включая, но не ограничиваясь, если Покупатель отказался от приемки и/или оплаты заказанного и доставленного Товара, Продавец вправе реализовать свое право на самозащиту, а именно: не принимать от него будущие Заказы.
            </p>
            <p className="text-base text-textColor text-left md:text-left mt-5">
                10.4. В случае одностороннего отказа Продавца от исполнения договора розничной купли-продажи дистанционным способом в соответствии с пунктом 6.6. настоящей публичной оферты, Продавец вправе реализовать свое право на самозащиту, взыскать убытки с Покупателя. в случае, если Покупатель оплатил Товар или услуг общественного питания до его доставки курьерской службой, оплаченная сумма не возвращается.
            </p>
        </div>
    )
}

export default PublicOffer